import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UploadWizardService } from '../wizard.service';
import { ImageViewerService } from '../../../shared/image-viewer/image-viewer.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'upload-wizard-decorations',
  styleUrls: ['../wizard.component.scss', './decorations.component.scss'],
  templateUrl: './decorations.component.html',
})
export class UploadWizardDecorationsComponent implements OnInit {
  @Input() step;
  @Input() totalSteps;
  @Input() isMobile;
  @Input() projectId;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  constructor(
    public uploadWizardService: UploadWizardService,
    public imageViewerService: ImageViewerService,
    private firebaseService: FirebaseService
  ) {}

  ngOnInit() {
    this.uploadWizardService.getDecorations();
  }

  isDecorationSelected(decoration) {
    return this.uploadWizardService.specs.embellishment_level === decoration;
  }

  selectDecoration(decoration) {
    this.uploadWizardService.specs.embellishment_level = decoration;
  }

  zoom(event, index) {
    event.stopPropagation();
    const images = this.uploadWizardService.decorations.map(item => {
      return item.picture_url;
    });
    this.imageViewerService.setImages(images, index);
  }

  submit() {
    this.next.emit();
    this.firebaseService.logEvent('design_request_emb_level_select', {
      project_id: this.projectId,
      emb_level: this.uploadWizardService.specs.embellishment_level
    });
  }
}
